import _ from 'lodash';

import connect from 'components/lib/connect';
import CloseCustomerUnlinkModal from 'actions/customer/close_customer_unlink_modal';
import { CustomerUnlinkModal } from './customer_unlink_modal';
import UnlinkExternalCustomer from 'actions/external_customer_lookup/unlink_external_customer';

function mapStateToProps({ getProvider }) {
  const lookupStatus = getProvider('externalCustomerLookupStatus').get();
  const isUnlinkPending = getProvider('customerUnlink').isPending();

  const profile = getProvider('profile').get();
  const profileDef = getProvider('customerProfileDef').get();

  let flattenedProfile = _.pick(profile.toJs(), ['name', 'address', 'emails', 'phones', 'twitter']);
  flattenedProfile = _.pickBy(flattenedProfile, a => !_.isArray(a) || !_.isEmpty(a));

  const profileCustomAttributes = profileDef
    ? _.filter(profileDef.attributes, a => !!_.get(profile.customAttributes, a.attr))
    : [];

  const partitionedFields = _.partition(profileCustomAttributes, a => {
    return a.presentation === 'EDITABLE';
  });

  return {
    customerId: _.get(getProvider('profile').get(), 'id'),
    externalSystemName: _.get(lookupStatus, 'name'),
    fieldsToRemove: _.map(partitionedFields[1], f => f.label),
    fieldsToRemain: _.concat(
      _.map(partitionedFields[0], f => f.label),
      _.keys(flattenedProfile)
    ),
    isUnlinkPending,
  };
}

function mapExecuteToProps(executeAction) {
  return {
    onClose: () => {
      executeAction(CloseCustomerUnlinkModal);
    },
    onUnlink: customerId => {
      executeAction(UnlinkExternalCustomer, { customerId });
    },
  };
}

const CustomerUnlinkModalContainer = connect(mapStateToProps, mapExecuteToProps)(CustomerUnlinkModal);

export default CustomerUnlinkModalContainer;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/modals/customer_unlink_modal_container.jsx